
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study-courses",
      function () {
        return require("private-next-pages/study-courses/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/study-courses"])
      });
    }
  